import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { App, getRouter, vuetifyOptions, type IConfiguration } from '@fondationcss/ui'
import { useSdk } from '@fondationcss/sdk'
import { getCustomRoutes } from './routes'
import { sidebarItems, refreshSidebarBoards } from './menus'
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import 'vuetify/styles'
import '@fontsource/public-sans/400.css'
import '@fontsource/public-sans/500.css'
import '@fontsource/public-sans/600.css'
import '@fontsource/public-sans/700.css'
import '@fondationcss/ui/dist/style.css'

const config = {
  AppName: 'Heuriqa',
  SiteNameShort: 'Heuriqa',
  SiteNameLong: 'Byrnu Heuriqa',
  LogoLine1: 'Byrnu',
  LogoLine2: 'Heuriqa',
  Copyright: 'Copyright © 2026',
  DefaultLayout: 'byrnu-red-app',
  Logo: '/images/heuriqa.svg',
  SiteLogo: '/images/heuriqa.svg',
  SiteLogoAlt: '/images/heuriqa-alt.svg',
  HideLoginLogo: true,
  EnableAccessRequestButton: false,
  SidebarItems: sidebarItems,
} as IConfiguration

const vuetify = createVuetify({
  components,
  directives,
  ...vuetifyOptions,
})

const app = createApp(App)
const router = getRouter(getCustomRoutes)

app.provide('config', config)
app.provide('sdkOptions', { apiUrl: import.meta.env.VITE_API_URL ?? undefined })

app.use(vuetify)
app.component('font-awesome-icon', FontAwesomeIcon)
library.add(fas)
library.add(far)
app.use(createPinia())
app.use(PerfectScrollbarPlugin)
app.use(router)

// Load boards into sidebar once SDK is initialized and on first authenticated navigation
let sidebarLoaded = false
const sdk = useSdk()
router.beforeEach(async (_to: RouteLocationNormalized, _from: RouteLocationNormalized, next: NavigationGuardNext) => {
  if (!sidebarLoaded && sdk.initialized.value) {
    sidebarLoaded = true
    refreshSidebarBoards().catch(() => {
      sidebarLoaded = false // retry on next navigation
    })
  }
  next()
})

app.mount('#app')
